import { defineComponent as _defineComponent } from 'vue'
import { Release, TtPage } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { errorMutationNotification } from "@/utils";
import { customMoment, vueApp } from "@/main";
import { useQuery } from "@vue/apollo-composable";
import { computed, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTDeletePageModal',
  props: {
    pageId: null,
    value: { type: Boolean }
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageId: TtPage["id"];
  value: boolean;
};





const { result, loading, refetch } = useQuery<{ ttPage: TtPage }>(
  queries.ttPageReleases,
  {
    id: computed(() => props.pageId),
  },
  { fetchPolicy: "no-cache" }
);

const { $t } = useTranslation();


const ttPage = computed(() => result.value?.ttPage);
const selectedReleaseDates = ref<Release["releaseDate"][]>([]);

function toggleModal(val: boolean) {
  emit("input", val);
}

async function handleSubmit() {
  if (!ttPage.value) {
    return;
  }

  vueApp.$confirm.require({
    header: 'Delete page?',
    message: 'This action cannot be undone.',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      try {
        await apolloClient.mutate({
          mutation: mutations.deleteTtPage,
          variables: {
            id: props.pageId,
            releaseDates: selectedReleaseDates.value,
          },
        });

        vueApp.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Page deleted',
          life: 3000
        });

        emit("submit");
        toggleModal(false);
      } catch (err) {
        errorMutationNotification(err);
      }
    },
    reject: () => {
      // Optional: Handle rejection
    }
  });
}

function formatDate(dateString: string) {
  return customMoment(dateString).format("ddd, DD MMM YYYY");
}

watch(
  () => props.value,
  (val) => {
    if (val) {
      resetForm();
      refetch();
    }
  }
);

function resetForm() {
  selectedReleaseDates.value = [];
}

return { __sfc: true,props, emit, result, loading, refetch, $t, ttPage, selectedReleaseDates, toggleModal, handleSubmit, formatDate, resetForm }
}

})